import { render, staticRenderFns } from "./EnquiryReservations.vue?vue&type=template&id=8818b434&"
import script from "./EnquiryReservations.vue?vue&type=script&lang=js&"
export * from "./EnquiryReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports